import { render, staticRenderFns } from "./MedicalNav.vue?vue&type=template&id=235983e0&scoped=true&"
import script from "./MedicalNav.vue?vue&type=script&lang=js&"
export * from "./MedicalNav.vue?vue&type=script&lang=js&"
import style0 from "./MedicalNav.vue?vue&type=style&index=0&id=235983e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235983e0",
  null
  
)

export default component.exports